import useAxiosService from './useAxiosService'
import { useProfile } from 'hooks'
import { IFileResponse } from 'interfaces'
import { IResponse } from 'interfaces/services'

export const useFileService = () => {
  const { post, get } = useAxiosService()
  const { userId } = useProfile()

  const postFilesToServer = async (images: Array<any>) => {
    const response: any = await post(`/clinic/upload`, {
      clinic_id: userId,
      assets: images
    })
    return response as IResponse<any>
  }

  const getUrlFile = async (id: number, isBase64?: boolean) => {
    const base64 = isBase64 ? 'true' : 'false'
    const response: any = await get(`/file/${id}?base64=${base64}`)
    return {
      ...response,
      data: response?.data
    } as IResponse<IFileResponse>
  }

  return { postFilesToServer, getUrlFile }
}
